import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CategoryRow from '../category-row/category-row';
import ProductListItem from '../product-list-item/product-list-item';

import { ProductTypeProp } from '../../../../shared/utils/prop-types/prop-types';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import './category-list.scss';

function CategoryList(props) {
  const {
    parentCategory,
    categories,
    productType,
    isProductList,
    showStaggeredURL = false
  } = props;

  const uniqueProducts = useMemo(() => {
    if (!isArrayWithLength(categories) || !isProductList) {
      return [];
    }

    const allProducts = categories.flatMap(category => category.products);
    return Array.from(
      new Map(allProducts.map(product => [product.code, product])).values()
    ).sort((a, b) => a.name.localeCompare(b.name));
  }, [categories, isProductList]);

  if (!Array.isArray(categories)) {
    return null;
  }

  return !isProductList ? (
    <ul styleName="container">
      {categories.map(
        (category, idx) =>
          (isArrayWithLength(category?.products) ||
            /accessories/i.test(category?.code) ||
            /tiresTires|wheelsWheels/.test(parentCategory?.code)) && (
            <li key={idx} styleName="category-list-item">
              <CategoryRow
                category={category}
                parentCategory={parentCategory}
                productType={productType}
                showStaggeredURL={showStaggeredURL}
              />
            </li>
          )
      )}
    </ul>
  ) : (
    <div styleName="products-list-container">
      {isArrayWithLength(uniqueProducts) && (
        <>
          <div styleName="header">{`${
            uniqueProducts.length
          } ${parentCategory.name.replace(' Wheels', '')} models`}</div>
          <ul styleName="products-list">
            {uniqueProducts.map((product, idx) => (
              <li key={`${product.code}-${idx}`} styleName="product-list-item">
                <ProductListItem product={product} productType={productType} />
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

CategoryList.propTypes = {
  categories: PropTypes.array,
  isProductList: PropTypes.bool,
  parentCategory: PropTypes.object,
  productType: ProductTypeProp,
  showStaggeredURL: PropTypes.bool
};

export default CategoryList;
